import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intersection-observer';
import "modaal";

// BootstrapのJSモジュールで必要なもののみimport
import 'popper.js';
// import 'bootstrap';
import "bootstrap/js/dist/util";
// import "bootstrap/js/dist/alert";
import "bootstrap/js/dist/button";
// import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/index";
// import "bootstrap/js/dist/modal";
// import "bootstrap/js/dist/popover";
// import "bootstrap/js/dist/scrollspy";
import "bootstrap/js/dist/tab";
// import "bootstrap/js/dist/toast";
// import "bootstrap/js/dist/tooltip";


// import Rellax from 'rellax';
// import ScrollOut from 'scroll-out';
// import smoothscroll from 'smoothscroll-polyfill';
import YouTubePlayer from './modules/YouTubePlayer';

(function ($) {
  'use strict';

  // Modaal
  // ---------------------------------------
  $(".js-modaal").modaal({
    animation_speed: 100,
    after_callback_delay: 100,
    after_open: modaalVideoPlay,
    before_close: modaalVideoPause,
  });
  function modaalVideoPlay(e) {
    // console.log("After open");
    // console.log($(e).attr("id"));
    $(e).find(".__video-embed")[0].play();
  }
  function modaalVideoPause(e) {
    // console.log("After Close");
    // console.log($(e).attr("id"));
    $(e).find(".__video-embed")[0].pause();
  }


  // nav toggler
  // ---------------------------------------
  let menuToggler = document.getElementById('menuToggler');
  let menuTogglerLabel = document.getElementById('menuTogglerLabel');
  let sidebar = document.getElementById('l-nav');
  let menuItems = document.getElementsByClassName('p-nav__list__item');

  if (menuToggler) {
    menuToggler.addEventListener('change', function () {
      if (menuToggler.checked) {
        menuTogglerLabel.setAttribute('aria-pressed', 'true');
        menuTogglerLabel.setAttribute('aria-expanded', 'true');
        sidebar.setAttribute('aria-hidden', 'false');
      } else {
        menuTogglerLabel.setAttribute('aria-pressed', 'false');
        menuTogglerLabel.setAttribute('aria-expanded', 'false');
        sidebar.setAttribute('aria-hidden', 'true');
      }

      for (let menuItem of menuItems) {
        if (menuToggler.checked) {
          menuItem.setAttribute('tabindex', '0');
        } else {
          menuItem.setAttribute('tabindex', '-1');
        }
      }
    });
  }


  // smooth scroll
  // ---------------------------------------------
  // smoothscroll.polyfill();
  // document.addEventListener('click', (e) => {
  //   const target = e.target;
  //   // clickした要素がclass属性、js-smooth-scrollを含まない場合は処理を中断
  //   if (!target.classList.contains('js-smooth-scroll')) return;
  //   e.preventDefault();
  //   const targetId = target.hash;
  //   const targetElement = document.querySelector(targetId);
  //   // 画面上部から要素までの距離
  //   const rectTop = targetElement.getBoundingClientRect().top;
  //   // 現在のスクロール距離
  //   const offsetTop = window.pageYOffset;
  //   // スクロール位置に持たせるバッファ
  //   const buffer = 90;
  //   const top = rectTop + offsetTop - buffer;

  //   window.scrollTo({
  //     top,
  //     behavior: 'smooth'
  //   });
  // });


  // category chart animation
  // ---------------------------------------------
  const categoryChartObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const polygon = entry.target.querySelector('animate');
          if (polygon && !polygon.classList.contains('-animated')) {
            polygon.beginElement();
            polygon.classList.add('-animated');
          }
        }
      });
    },
    {
      threshold: [1]
    }
  );
  document.querySelectorAll('.category-chart').forEach((el) => {
    categoryChartObserver.observe(el);
  });


  // Youtube Player
  // ---------------------------------------------
  document.querySelectorAll('.js-youtube').forEach((el) => {
    new YouTubePlayer(el);
  });

})(jQuery);
